module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [(_vm.canAccess('loan-plan-view-any')) ? _c('div', {
    staticClass: "info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Loan Plan List")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  }, [(_vm.canAccess('loan-plan-create')) ? _c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.newModal
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add New\r\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('label', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.per_page),
      expression: "per_page"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "name": "per_page",
      "aria-controls": "example1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.per_page = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeFilter()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "input-group pull-right input-group-sm",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.table_search),
      expression: "table_search"
    }],
    staticClass: "form-control pull-right",
    attrs: {
      "type": "text",
      "name": "table_search",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.table_search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeFilter()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.table_search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "~click": function($event) {
        return _vm.changeFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.rows.data), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s((index + _vm.pagination.from)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.name))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.planType))]), _vm._v(" "), _c('td', [(row.planType === 'normalReduced' || row.planType === 'special' || row.planType === 'custom') ? _c('span', [_vm._v("\r\n                      " + _vm._s(_vm.getplanamt(row)) + "\r\n                    ")]) : _c('span', [_vm._v("\r\n                      " + _vm._s(row.amount) + "\r\n                    ")])]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.amount))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.recoveryType))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(row.noOfPayments))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.status == 'active') ? _c('div', [_c('span', {
      staticClass: "label label-success"
    }, [_vm._v("Active")])]) : _c('div', [_c('span', {
      staticClass: "label label-danger"
    }, [_vm._v("InActive")])])]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "btn-group dropup"
    }, [_vm._m(1, true), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu dropdown-menu-right",
      attrs: {
        "role": "menu"
      }
    }, [(_vm.canAccess('loan-plan-view')) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.viewPlan(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-eye"
    }), _vm._v(" View")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-plan-update')) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.editModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Update")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-plan-delete')) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.deleteModal(row.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Delete")])]) : _vm._e()])])])])
  }), 0)])]), _vm._v(" "), (_vm.pagination.current_page > 0) ? _c('div', {
    staticClass: "box-footer clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("\r\n              Showing " + _vm._s(_vm.pagination.from) + " to " + _vm._s(_vm.pagination.to) + " of " + _vm._s(_vm.pagination.total) + " entries\r\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('ul', {
    staticClass: "pagination pagination-sm no-margin pull-right"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'first')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'prev')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), (_vm.pagination.current_page > 3) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 2) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 1) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "active",
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page))])]), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 4)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 1))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 5)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 6)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 3))])]) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 3)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 2)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 1)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page))])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'next')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Next")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'last')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("»")])])])])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewPlan"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [(_vm.planDetail) ? _c('div', {
    staticClass: "card-body"
  }, [_c('ul', {
    staticClass: "list-group ui-sortable"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Plan Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(" " + _vm._s(_vm.planDetail.name))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Plan Type")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(" " + _vm._s(_vm.planDetail.planType))])]), _c('li', {
    staticClass: "list-group-item"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Recovery Type")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(" " + _vm._s(_vm.planDetail.recoveryType))])]), _c('li', {
    staticClass: "list-group-item"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Type of Interest")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(" " + _vm._s(_vm.planDetail.typeOfInterest))])]), _c('li', {
    staticClass: "list-group-item"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Rate of Interest (%)")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(" " + _vm._s(_vm.planDetail.rateOfInterest))])]), _c('li', {
    staticClass: "list-group-item"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("EMI")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(" " + _vm._s(_vm.calculatorData.emi))])]), _c('li', {
    staticClass: "list-group-item"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("No. of Payments")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(" " + _vm._s(_vm.planDetail.noOfPayments))])]), _c('li', {
    staticClass: "list-group-item"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Include GST")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(" " + _vm._s(_vm.planDetail.includeGst))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Status")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(" " + _vm._s(_vm.planDetail.status))])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card"
  }, [(_vm.planDetail) ? _c('div', {
    staticClass: "card-body"
  }, [_c('ul', {
    staticClass: "list-group ui-sortable"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Create Date")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(" " + _vm._s(_vm.planDetail.created_at))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Amount")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [(_vm.planDetail.planType === 'normalReduced' || _vm.planDetail.planType === 'special' || _vm.planDetail.planType === 'custom') ? _c('span', [_vm._v("\r\n                          " + _vm._s(_vm.getplanamt(_vm.planDetail)) + "\r\n                        ")]) : _c('span', [_vm._v("\r\n                          " + _vm._s(_vm.planDetail.amount) + "\r\n                        ")])])]), _c('li', {
    staticClass: "list-group-item"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("File Charge")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(" " + _vm._s(_vm.planDetail.fileCharge))])]), _c('li', {
    staticClass: "list-group-item"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("File Charge Include Amount")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(" " + _vm._s(_vm.planDetail.fileChargeIncludeAmt))])]), _c('li', {
    staticClass: "list-group-item"
  }, [(_vm.planDetail.planType == 'normalReduced') ? _c('span', {
    staticClass: "text"
  }, [_vm._v("Processing Fee Amt")]) : _vm._e(), _vm._v(" "), (_vm.planDetail.planType !== 'normalReduced') ? _c('span', {
    staticClass: "text"
  }, [_vm._v("Processing Fee (%)")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(" " + _vm._s(_vm.planDetail.processingFee))])]), _c('li', {
    staticClass: "list-group-item"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Processing Fee Include Amount")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(" " + _vm._s(_vm.planDetail.processingFeeIncludeAmt))])]), _c('li', {
    staticClass: "list-group-item"
  }, [(_vm.planDetail.planType == 'normalReduced') ? _c('span', {
    staticClass: "text"
  }, [_vm._v("Insurance Fee Amt")]) : _vm._e(), _vm._v(" "), (_vm.planDetail.planType !== 'normalReduced') ? _c('span', {
    staticClass: "text"
  }, [_vm._v("Insurance Fee (%)")]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(" " + _vm._s(_vm.planDetail.insuranceFee))])]), _c('li', {
    staticClass: "list-group-item"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Insurance Fee Include Amount")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(" " + _vm._s(_vm.planDetail.insuranceFeeIncludeAmt))])]), _c('li', {
    staticClass: "list-group-item"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("Advance Installment")]), _vm._v(" "), (_vm.planDetail.advanceInstallment) ? _c('small', {
    staticClass: "label label-warning"
  }, [_c('i', {
    staticClass: "far fa-clock"
  }), _vm._v(" " + _vm._s(_vm.planDetail.advanceInstallment))]) : _vm._e()])])]) : _vm._e()])])])]), _vm._v(" "), _vm._m(4)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "newModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(5), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "modal-title"
  }, [_vm._v("Add New Plan")]), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "modal-title"
  }, [_vm._v("Update Plan")]), _vm._v(" "), _c('h4', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.emiCal),
      expression: "emiCal"
    }],
    staticClass: "modal-title"
  }, [_vm._v("Plan EMI")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.emiCal),
      expression: "emiCal"
    }],
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('th', [_vm._v("Number Of Payments : " + _vm._s(_vm.calculatorData.noOfPayment))]), _vm._v(" "), _c('th', [_vm._v("Total Amount To pay : " + _vm._s(_vm.calculatorData.totalAmtToPay))]), _vm._v(" "), _c('th', [_vm._v("Preloan EMI Interest : " + _vm._s(_vm.calculatorData.preLoanEmiInterest))]), _vm._v(" "), (this.form.planType === 'normal') ? _c('th', [_vm._v("Principal Amount : " + _vm._s(this.form.amount))]) : _vm._e(), _vm._v(" "), (this.form.planType !== 'normal') ? _c('th', [_vm._v("Paid Amount : " + _vm._s(this.form.amount))]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row table-responsive"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.TableColumn,
      "rows": _vm.calculatorEmi,
      "line-numbers": true,
      "styleClass": "vgt-table condensed",
      "max-height": "400px",
      "fixed-header": true,
      "sort-options": {
        enabled: false,
      }
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'id') ? _c('span', [_c('a', {
          staticClass: "btn btn-info btn-xs",
          attrs: {
            "href": props.row.id
          }
        }, [_c('i', {
          staticClass: "fa fa-eye"
        })]), _vm._v(" "), _c('a', {
          staticClass: "btn btn-success btn-xs",
          attrs: {
            "href": props.row.id
          }
        }, [_c('i', {
          staticClass: "fa fa-pencil-alt"
        })])]) : _c('span', [_vm._v("\r\n                            " + _vm._s(props.formattedRow[props.column.field]) + "\r\n                          ")])]
      }
    }])
  })], 1)])])]), _vm._v(" "), _c('form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.emiCal),
      expression: "!emiCal"
    }],
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.editMode ? _vm.updateLoanPlan() : _vm.createLoanPlan()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [(!this.editMode) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.planType),
      expression: "form.planType"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('planType')
    },
    attrs: {
      "name": "planType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "planType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.setPlanDefaultValue]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Loan Plan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "normal"
    }
  }, [_vm._v("Normal Plan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "normalReduced"
    }
  }, [_vm._v("Normal Reduced Plan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "special"
    }
  }, [_vm._v("Special Plan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "custom"
    }
  }, [_vm._v("Custom Plan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "manual"
    }
  }, [_vm._v("Manual Plan")]), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "planType"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.editMode) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(8), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.planType),
      expression: "form.planType"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('planType')
    },
    attrs: {
      "name": "planType",
      "disabled": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "planType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.setPlanDefaultValue]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Loan Plan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "normal"
    }
  }, [_vm._v("Normal Plan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "normalReduced"
    }
  }, [_vm._v("Normal Reduced Plan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "special"
    }
  }, [_vm._v("Special Plan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "custom"
    }
  }, [_vm._v("Custom Plan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "manual"
    }
  }, [_vm._v("Manual Plan")]), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "planType"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(10), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('name')
    },
    attrs: {
      "type": "text",
      "name": "name"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "name"
    }
  })], 1), _vm._v(" "), (this.form.planType === 'normal' || this.form.planType === 'normalReduced' || this.form.planType === 'interest') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(11), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.rateOfInterest),
      expression: "form.rateOfInterest"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('rateOfInterest')
    },
    attrs: {
      "type": "number",
      "name": "rateOfInterest",
      "step": ".01"
    },
    domProps: {
      "value": (_vm.form.rateOfInterest)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "rateOfInterest", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "rateOfInterest"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.form.planType === 'custom') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(12), _c('br'), _vm._v(" "), _vm._l((_vm.form.plan_details), function(input, k) {
    return _c('span', {
      key: k,
      staticStyle: {
        "display": "flex",
        "flex-flow": "row wrap",
        "align-items": "center"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.emi),
        expression: "input.emi"
      }],
      staticClass: "form-control",
      class: {
        'is-invalid': _vm.form.errors.has('noOfPayments'),
      },
      staticStyle: {
        "width": "42%"
      },
      attrs: {
        "type": "number",
        "name": "noOfPayments",
        "placeholder": "EMI"
      },
      domProps: {
        "value": (input.emi)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input, "emi", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('has-error', {
      attrs: {
        "form": _vm.form,
        "field": "noOfPayments"
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.noOfPayments),
        expression: "input.noOfPayments"
      }],
      staticClass: "form-control",
      class: {
        'is-invalid': _vm.form.errors.has('noOfPayments'),
      },
      staticStyle: {
        "width": "42%"
      },
      attrs: {
        "type": "number",
        "name": "noOfPayments",
        "placeholder": "No. of payments"
      },
      domProps: {
        "value": (input.noOfPayments)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input, "noOfPayments", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('has-error', {
      attrs: {
        "form": _vm.form,
        "field": "noOfPayments"
      }
    }), _vm._v("\r\n                                 \r\n                                  "), _c('span', [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (k || (!k && _vm.form.plan_details.length > 1)),
        expression: "k || ( !k && form.plan_details.length > 1)"
      }],
      staticClass: "fa fa-minus-circle btn-danger",
      on: {
        "~click": function($event) {
          return _vm.remove(k)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (k == _vm.form.plan_details.length - 1),
        expression: "k == form.plan_details.length-1"
      }],
      staticClass: "fa fa-plus-circle btn-success",
      on: {
        "~click": function($event) {
          return _vm.add(k)
        }
      }
    })])], 1)
  })], 2) : _vm._e(), _vm._v(" "), (this.form.planType === 'manual') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(13), _c('br'), _vm._v(" "), _vm._l((_vm.form.plan_details), function(input, k) {
    return _c('span', {
      key: k,
      staticStyle: {
        "display": "flex",
        "flex-flow": "row wrap",
        "align-items": "center"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.principal),
        expression: "input.principal"
      }],
      staticClass: "form-control",
      class: {
        'is-invalid': _vm.form.errors.has('principal'),
      },
      staticStyle: {
        "width": "42%"
      },
      attrs: {
        "type": "number",
        "name": "principal",
        "placeholder": "Principal"
      },
      domProps: {
        "value": (input.principal)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input, "principal", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('has-error', {
      attrs: {
        "form": _vm.form,
        "field": "principal"
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (input.intrest),
        expression: "input.intrest"
      }],
      staticClass: "form-control",
      class: {
        'is-invalid': _vm.form.errors.has('intrest'),
      },
      staticStyle: {
        "width": "42%"
      },
      attrs: {
        "type": "number",
        "name": "intrest",
        "placeholder": "Interest"
      },
      domProps: {
        "value": (input.intrest)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(input, "intrest", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('has-error', {
      attrs: {
        "form": _vm.form,
        "field": "intrest"
      }
    }), _vm._v("\r\n                              \r\n                                 \r\n                                  "), _c('span', [_c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (k || (!k && _vm.form.plan_details.length > 1)),
        expression: "k || ( !k && form.plan_details.length > 1)"
      }],
      staticClass: "fa fa-minus-circle btn-danger",
      on: {
        "~click": function($event) {
          return _vm.remove(k)
        }
      }
    }), _vm._v(" "), _c('i', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (k == _vm.form.plan_details.length - 1),
        expression: "k == form.plan_details.length-1"
      }],
      staticClass: "fa fa-plus-circle btn-success",
      on: {
        "~click": function($event) {
          return _vm.addManualEmi(k)
        }
      }
    })])], 1)
  })], 2) : _vm._e(), _vm._v(" "), (this.form.planType !== 'custom' && this.form.planType !== 'manual') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(14), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.noOfPayments),
      expression: "form.noOfPayments"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('noOfPayments'),
    },
    attrs: {
      "type": "number",
      "name": "noOfPayments"
    },
    domProps: {
      "value": (_vm.form.noOfPayments)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "noOfPayments", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "noOfPayments"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.form.planType === 'special') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(15), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.emi),
      expression: "form.emi"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('emi'),
    },
    attrs: {
      "type": "number",
      "name": "emi"
    },
    domProps: {
      "value": (_vm.form.emi)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "emi", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "emi"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(16), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.recoveryType),
      expression: "form.recoveryType"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'recoveryType'
      ),
    },
    attrs: {
      "name": "recoveryType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "recoveryType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Recovery type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Daily"
    }
  }, [_vm._v("Daily")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Weekly"
    }
  }, [_vm._v("Weekly")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BiWeekly"
    }
  }, [_vm._v("BiWeekly")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "HalfMonth"
    }
  }, [_vm._v("Half Month")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Monthly"
    }
  }, [_vm._v("Monthly")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Year"
    }
  }, [_vm._v("Yearly")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "OneTime"
    }
  }, [_vm._v("One Time")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "recoveryType"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(17), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.noOfAdvanceInstallment),
      expression: "form.noOfAdvanceInstallment"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('noOfAdvanceInstallment'),
    },
    attrs: {
      "name": "noOfAdvanceInstallment",
      "placeholder": "no of advance installation"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "noOfAdvanceInstallment", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("No of Advance Installment")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "noOfAdvanceInstallment"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(18), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.holidayInclude),
      expression: "form.holidayInclude"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('holidayInclude'),
    },
    attrs: {
      "name": "holidayInclude"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "holidayInclude", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Holiday Include")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v("No")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "holidayInclude"
    }
  })], 1), _vm._v(" "), (this.form.planType === 'normal' || this.form.planType === 'normalReduced') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(19), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.typeOfInterest),
      expression: "form.typeOfInterest"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('typeOfInterest'),
    },
    attrs: {
      "name": "typeOfInterest"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "typeOfInterest", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Interest Type")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "reduced"
    }
  }, [_vm._v("Reduced")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fixed"
    }
  }, [_vm._v("Flat")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "typeOfInterest"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(20), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.includeGst),
      expression: "form.includeGst"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('includeGst'),
    },
    attrs: {
      "name": "includeGst"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "includeGst", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.paidAmount]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v("No")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "includeGst"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [(this.form.planType === 'normal') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(21), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.amount),
      expression: "form.amount"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('amount'),
    },
    attrs: {
      "type": "number",
      "name": "amount"
    },
    domProps: {
      "value": (_vm.form.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "amount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "amount"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.form.planType !== 'normal') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(22), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.planAmount),
      expression: "form.planAmount"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('planAmount'),
    },
    attrs: {
      "type": "number",
      "name": "planAmount"
    },
    domProps: {
      "value": (_vm.form.planAmount)
    },
    on: {
      "change": _vm.paidAmount,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "planAmount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "planAmount"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.form.planType !== 'normal') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(23), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.amount),
      expression: "form.amount"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('amount'),
    },
    attrs: {
      "type": "number",
      "name": "amount",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.form.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "amount", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "amount"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(24), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.fileChargeIncludeAmt),
      expression: "form.fileChargeIncludeAmt"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('fileChargeIncludeAmt'),
    },
    attrs: {
      "name": "fileChargeIncludeAmt"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "fileChargeIncludeAmt", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v("No")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "fileChargeIncludeAmt"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(25), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.fileCharge),
      expression: "form.fileCharge"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('fileCharge'),
    },
    attrs: {
      "type": "number",
      "name": "fileCharge"
    },
    domProps: {
      "value": (_vm.form.fileCharge)
    },
    on: {
      "change": _vm.paidAmount,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "fileCharge", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "fileCharge"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(26), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.processingFeeIncludeAmt),
      expression: "form.processingFeeIncludeAmt"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('processingFeeIncludeAmt'),
    },
    attrs: {
      "name": "processingFeeIncludeAmt"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "processingFeeIncludeAmt", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v("No")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "processingFeeIncludeAmt"
    }
  })], 1), _vm._v(" "), (this.form.planType !== 'normal') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(27), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.processingFeePer),
      expression: "form.processingFeePer"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('processingFeePer'),
    },
    attrs: {
      "type": "number",
      "step": ".01",
      "name": "processingFeePer"
    },
    domProps: {
      "value": (_vm.form.processingFeePer)
    },
    on: {
      "change": _vm.paidAmount,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "processingFeePer", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "processingFeePer"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.form.planType !== 'normal') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(28), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.processingFee),
      expression: "form.processingFee"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('processingFee'),
    },
    attrs: {
      "type": "number",
      "name": "processingFee",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.form.processingFee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "processingFee", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "processingFee"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.form.planType === 'normal') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(29), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.processingFee),
      expression: "form.processingFee"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('processingFee'),
    },
    attrs: {
      "type": "number",
      "name": "processingFee"
    },
    domProps: {
      "value": (_vm.form.processingFee)
    },
    on: {
      "change": _vm.paidAmount,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "processingFee", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "processingFee"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(30), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.insuranceFeeIncludeAmt),
      expression: "form.insuranceFeeIncludeAmt"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('insuranceFeeIncludeAmt'),
    },
    attrs: {
      "name": "insuranceFeeIncludeAmt"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "insuranceFeeIncludeAmt", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v("No")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "insuranceFeeIncludeAmt"
    }
  })], 1), _vm._v(" "), (this.form.planType !== 'normal') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(31), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.insuranceFeePer),
      expression: "form.insuranceFeePer"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('insuranceFeePer'),
    },
    attrs: {
      "type": "number",
      "step": ".01",
      "name": "insuranceFeePer"
    },
    domProps: {
      "value": (_vm.form.insuranceFeePer)
    },
    on: {
      "change": _vm.paidAmount,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "insuranceFeePer", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "insuranceFeePer"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.form.planType !== 'normal') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(32), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.insuranceFee),
      expression: "form.insuranceFee"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('insuranceFee'),
    },
    attrs: {
      "type": "number",
      "name": "insuranceFee",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.form.insuranceFee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "insuranceFee", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "insuranceFee"
    }
  })], 1) : _vm._e(), _vm._v(" "), (this.form.planType === 'normal') ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(33), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.insuranceFee),
      expression: "form.insuranceFee"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('insuranceFee'),
    },
    attrs: {
      "type": "number",
      "name": "insuranceFee"
    },
    domProps: {
      "value": (_vm.form.insuranceFee)
    },
    on: {
      "change": _vm.paidAmount,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "insuranceFee", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "insuranceFee"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(34), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('status'),
    },
    attrs: {
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Status View")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "active"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "inActive"
    }
  }, [_vm._v("Inactive")])]), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "status"
    }
  })], 1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editMode),
      expression: "!editMode"
    }],
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\r\n                  SAVE\r\n                ")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editMode),
      expression: "editMode"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\r\n                  Update\r\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.calculateEMI
    }
  }, [_vm._v("\r\n                  Calculate EMI\r\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\r\n                  CANCEL\r\n                ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.emiCal),
      expression: "emiCal"
    }],
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.backToLoanPlan
    }
  }, [_vm._v("\r\n                BACK\r\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\r\n                CANCEL\r\n              ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', [_vm._v("Sr. No.")]), _vm._v(" "), _c('th', [_vm._v("Plan Name")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Plan Type")]), _vm._v(" "), _c('th', [_vm._v("Loan")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Disbursement")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Collection")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Tenure")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-flat btn-xs dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\r\n                      Task "), _c('span', {
    staticClass: "caret"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Plan Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger pull-left",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Select Loan Type\r\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('option', {
    staticClass: "red",
    attrs: {
      "value": "interest"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Premium")]), _vm._v(" (Interest Plan)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Select Loan Type\r\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('option', {
    staticClass: "red",
    attrs: {
      "value": "interest"
    }
  }, [_c('span', {
    staticClass: "red"
  }, [_vm._v("Premium")]), _vm._v(" (Interest Plan)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Plan Name "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Rate of Interest "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Payments Details "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Payments Details "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Number of EMI "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("EMI Amt. "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Recovery type\r\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("No of Advance Installment "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Holiday Exclude "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Type of Interest\r\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("GST Charge Include "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Plan Amount "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Plan Amount "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Paid Amount "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("File Charge Include "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("File Charge\r\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Processing Fee Charge Include "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Processing Fee In Percentage (%)\r\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Processing Fee In Amount\r\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Processing Fee In Percentage (%)\r\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Insurance Fee Charge Include "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Insurance Fee In Percentage (%)\r\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Insurance Fee In Amount\r\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Insurance Fee In Percentage (%)\r\n                              "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("Select Status "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46485e80!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/master/LoanPlan.vue
// module id = 798
// module chunks = 0